import t from 'lib/i18n';
import useModal from "hooks/useModal";
import useGTM from "hooks/useGTM";
import { trackFavouritesSelectFavouriteIntent } from "lib/tracking";

import "styles/components/favourites/ticket-selection.scss";

import { TicketSelectionModal } from "components/favourites/TicketSelection";
import Button, { ButtonVariants } from 'components/ui/Button';

const TicketSelection = () => {
  const { showModal } = useModal();
  const dispatchGTM = useGTM();

  const handleClick = () => {
    dispatchGTM(trackFavouritesSelectFavouriteIntent());
    showModal(<TicketSelectionModal />, {
      fixedHeight: true,
      takeover: true,
    });
  };

  return (
    <div className="otrl-jp__favourite-ticket-selection">
      <p>
        {t("favourites.ticketSelection.linkTextHelper")}
        <br />
        <Button
          className="otrl-jp__favourite-ticket-selection__button"
          variant={ButtonVariants.TEXT}
          textUnderline={true}
          onClick={handleClick}
        >
          {t("favourites.ticketSelection.linkText")}
        </Button>
      </p>
    </div>
  );
}

export default TicketSelection;
